import { ICubic, ReportTableColumn } from "../store/types";

export const getCubicData: ICubic = {
  cubic1: { filter: "bm_irr", title: "IRR" },
  cubic2: { filter: "bm_dpi", title: "DPI" },
  cubic3: { filter: "bm_moic", title: "MOIC" },
  cubic4: { filter: "bm_irr", title: "IRR" },
  cubic5: { filter: "bm_irr", title: "IRR" },
  cubic6: { filter: "bm_irr", title: "IRR" }
};

// export const tableColumns: ReportTableColumn[] = [
//   { aggregation: "bm_moic", key: "bm_moic", dateRange: { value: "fromInception" } },
//   { aggregation: "bm_dpi", key: "bm_dpi", dateRange: { value: "fromInception" } },
//   { aggregation: "bm_pme", key: "bm_pme", dateRange: { value: "fromInception" } },
//   { aggregation: "bm_irr", key: "bm_irr", dateRange: { value: "fromInception" } },
//   { aggregation: "bm_irr", key: "bm_irr-1", dateRange: { value: "lastYear" } },
//   {
//     aggregation: "bm_moic",
//     key: "bm_moic-1",
//     dateRange: { value: "last3Years" }
//   }
// ];

export const benchmarkColumns: ReportTableColumn[] = [
  { aggregation: "bm_irr", key: "bm_irr", dateRange: { value: "fromInception" } },
  { aggregation: "bm_irr", key: "bm_irr-dup", dateRange: { value: "last3Years" } },
  { aggregation: "bm_irr", key: "bm_irr-dup-dup", dateRange: { value: "last5Years" } },
  { aggregation: "bm_moic", key: "bm_moic", dateRange: { value: "fromInception" } },
  { aggregation: "bm_dpi", key: "bm_dpi", dateRange: { value: "fromInception" } },
  { aggregation: "bm_pme", key: "bm_pme" }
];

export const benchmarkColumnsFreemium: ReportTableColumn[] = [
  { aggregation: "bm_irr", key: "bm_irr", dateRange: { value: "ytd" } },
  { aggregation: "bm_moic", key: "bm_moic", dateRange: { value: "ytd" } },
  { aggregation: "bm_dpi", key: "bm_dpi", dateRange: { value: "ytd" } }
];

export enum benchmarkFilters {
  ASSET_CLASS = "asset_class",
  SUB_ASSET = "sub_asset",
  TYPE = "type",
  VINTAGE = "vintage",
  GEOGRAPHY = "geography",
  CURRENCY = "currency"
}

export const filterOptions = [
  { label: "Asset Class", field: benchmarkFilters.ASSET_CLASS },
  { label: "Sub Asset", field: benchmarkFilters.SUB_ASSET },
  { label: "Type", field: benchmarkFilters.TYPE },
  { label: "Vintage", field: benchmarkFilters.VINTAGE },
  { label: "Geography", field: benchmarkFilters.GEOGRAPHY },
  { label: "Currency", field: benchmarkFilters.CURRENCY }
];
